/**
 * LocaleContext — thin shim over GlobalState ApplicationContext
 * Provides useLocale() hook that reads/sets locale via SET_LOCALE dispatch
 */
import { useContext } from "react";
import { ApplicationContext } from "./GlobalState";

export function useLocale() {
  const { state, dispatch } = useContext(ApplicationContext);

  const locale = state.locale || "en";

  function setLocale(newLocale) {
    dispatch({ type: "SET_LOCALE", payload: newLocale });
  }

  return { locale, setLocale };
}
